// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default-layout__body{display:block}.default-layout__body__content{padding-top:5rem;min-height:calc(100vh - 414px)}@media (max-width:767.98px){.default-layout__body__content{min-height:calc(100vh - 414px)}}", ""]);
// Exports
module.exports = exports;
